import { capitalize } from 'string-transform';

import type { ArticleAddress } from '../models/shipments';

export const capitalizeFirstLetter = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const formatAddress = (address: Partial<ArticleAddress>) => {
  const { addressLine1, addressLine2, addressLine3, suburb, state, postCode } = address;
  const addressLines: string[] = [];
  if (addressLine1) addressLines.push(capitalize(addressLine1.toLowerCase()));
  if (addressLine2) addressLines.push(capitalize(addressLine2.toLowerCase()));
  if (addressLine3) addressLines.push(capitalize(addressLine3.toLowerCase()));

  const statePostCode = state && postCode ? `${state.toUpperCase()} ${postCode}` : state?.toUpperCase() || postCode;
  const suburbStr = (suburb && capitalize(suburb.toLowerCase())) || '';
  const area = suburbStr && statePostCode ? `${suburbStr}, ${statePostCode}` : statePostCode || suburbStr;

  if (area) addressLines.push(area);

  return addressLines;
};
